<template>
  <div v-if="product">
    <VSlider
      :title="$t('related_drugs.other_products')"
      source="drugs/REQUEST_DRUGS_BOUGHT_WITH"
      :payload="sliderPayload"
      type="compact"
    />
  </div>
</template>


<script>
import VSlider from "@/components/VProductsSlider";

export default {
  name: "v-related-drugs-slider",
  components: {
    VSlider,
  },
  props: {
    product: Object,
  },
  data() {
    return {};
  },
  computed: {
    sliderPayload() {
      return {
        dUuid: this.product.uuid,
      };
    },
  },
  methods: {},
  fallbackI18n: {
    messages: {
      und: {
        related_drugs: {
          other_products: "Other products",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
